import logo from './logo.svg';
import './App.css';
import './Dashboardcontent.css';
import './components/Home.css';
import './Admin/OrderDetails.css';
import './components/Sidebar.css';
import Transaction from './Admin/Transaction';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { lazy, Suspense } from 'react';
import Spinners from './components/Spinners';
import Spark from './components/Spark';
const Plan = lazy(() => import("./Admin/Plan"));
const Dashboard = lazy(() => import("./Admin/Dashboard"));
const HomePage = lazy(() => import("./components/HomePage"));
const Login = lazy(()=> import("./components/Login"))

function App() {
  return (
    <>
      <Router basename="/app">
        <Suspense fallback={<Spinners />}>

        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/Login" element={<Login />} />
          <Route path="/Dashboard/*" element={<Dashboard />} />
          <Route path="/plans" element={<Plan />} />
          <Route path="/spark" element={<Spark />} />
        </Routes>
        </Suspense>
      </Router>
      <Toaster position="top-center" />
    </>
  );
}

export default App;
